import Repository from "@/repositories/RepositoryFactory";
import groupRepository from "../../repositories/groups";
import gpsDataRepository from "../../repositories/gpsDataRepository";
import APISTATE from "../../enums/APISTATE";

const GPSDataRepository = Repository.get("gpsData");

export default {
  namespaced: true,
  state: {
    gpsDataApiState: APISTATE.LOADED,
    gpsDataList: [],
    gpsDataFilterYear: undefined,
    gpsDataFilterMonth: undefined,
    gpsDataFilterEmployeeNumber: 0
  },
  mutations: {
    setApiState: (state, apiState) => {
      state.gpsDataApiState = apiState;
    },
    setGPSDataList: (state, response) => {
      state.gpsDataList = response;
      state.apiState = APISTATE.LOADED;
    },
    setGPSDataFilterYear: (state, response) => {
      state.gpsDataFilterYear = response;
    },
    setGPSDataFilterMonth: (state, response) => {
      state.gpsDataFilterMonth = response;
    },
    setGPSDataFilterEmployeeNumber: (state, response) => {
      state.gpsDataFilterEmployeeNumber = response;
    }
  },
  actions: {
    getAllGPSData({ commit }, dto) {
      commit("setApiState", APISTATE.LOADING);
      return new Promise((resolve, reject) => {
        GPSDataRepository
          .getGPSDataList(dto)
          .then((response) => {
            commit("setGPSDataList", response);
            commit("setApiState", APISTATE.LOADED);
            resolve();
          })
          .catch((error) => {
            commit("setApiState", APISTATE.ERROR);
            reject(error);
          });
      });
    },
    async updateGPSData({ commit}, gpsData) {
      commit('setApiState', APISTATE.LOADING);
      try {
        const response = await gpsDataRepository.updateGPSData(gpsData);
        commit('setApiState',APISTATE.LOADED)
      }
      catch (error) {
        console.error(error);
        commit('setApiState', APISTATE.ERROR);
      }
    },
    setYear({commit}, year) {
      commit("setGPSDataFilterYear", year)
    },
    setMonth({commit}, month) {
      commit("setGPSDataFilterMonth", month)
    },
    setEmployeeNumber ({commit}, employeeNumber) {
      commit("setGPSDataFilterEmployeeNumber", employeeNumber)
    },
    initYearMonth ({commit}) {
      
        const date = new Date();
        commit("setGPSDataFilterYear", date.getFullYear());
        commit("setGPSDataFilterMonth", date.getMonth());
      
    }
  },
  getters: {
    gpsDataList(state) {
      return state.gpsDataList
    },
    gpsDataApiState (state) {
      return state.gpsDataApiState
    },
    gpsDataFilterYear (state) {
      return state.gpsDataFilterYear
    },
    gpsDataFilterMonth (state) {
      return state.gpsDataFilterMonth
    },
    gpsDataFilterEmployeeNumber (state) {
      return state.gpsDataFilterEmployeeNumber
    }
  }
};
